import axios, { AxiosResponse } from "axios";
import { General } from "./general";
import ObraFilter from "../models/obraFilter.model";
import ObraTemporalFilter from "../models/obraTemporalFilter.model";
import { ObraApp } from "../models/obraApp.model";
import { ObraAppTemporal } from "../models/obraAppTemporal.model";

export function ObrasService(props?: any) {

    const getObrasApp = async (filter?: ObraFilter): Promise<AxiosResponse<ObraApp[]>> => {
        return axios.post<ObraApp[]>(`${General.API_URL}/GetObrasApp`, filter);

    }

    const getObrasAppTemporales = async (filter?: ObraTemporalFilter): Promise<AxiosResponse<ObraAppTemporal[]>> => {
        return axios.post<ObraAppTemporal[]>(`${General.API_URL}/GetObrasAppTemporales`, filter);

    }

    const saveObrasApp = async (obras: ObraApp[]): Promise<AxiosResponse<ObraApp[]>> => {
        return axios.post<ObraApp[]>(`${General.API_URL}/SaveObrasApp`, obras);

    }

    const saveObrasAppTemporales = async (obras: ObraAppTemporal[]): Promise<AxiosResponse<ObraAppTemporal[]>> => {
        return axios.post<ObraAppTemporal[]>(`${General.API_URL}/SaveObrasAppTemporales`, obras);

    }

    return (
        {
            getObrasApp,
            saveObrasApp,
            getObrasAppTemporales,
            saveObrasAppTemporales,
        }
    );

}